<template>
  <div class="row">
    <div class="col-12">
      <label :for="`input${name}`">{{title}}</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" :id="`${name}`">
            <i :class="`${icon} fa-fw`"></i>
          </span>
        </div>
        <input
          :type="`${type}`"
          :id="`${id}_input`"
          :name="name"
          class="form-control"
          :aria-label="name"
          :aria-describedby="name"
          :placeholder="placeholder"
          :value="actualVal"
          :required="required"
          :disabled="disabled"
          :readonly="readonly"

        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
    name: String,
    icon: String,
    title: String,
    time: String,
    type: {
    dataType: String,
		type: String,
		default: 'text',
	},
    "placeholder": String,
    "disabled": {
      type: Boolean,
      default: false
    },
    "required": {
      type: Boolean,
      default: false
    },
    "readonly": {
      type: Boolean,
      default: false
    },
    "value": {
      type: String,
      default: ''
    }
  },
  
  data: function() {
      return {
        listData: [],
        actualVal: this.value
      };
    },
    mounted() {
      this.popData();
    },
    methods: {
      popData: function() {
        var self = this;
        axios
          .get("occurrence/types")
          .then(function(response) {
            self.listData = response.data;
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    }
};

</script>